import React, { useState } from 'react';
import { adminApi } from '../services/api';

const PromoManagePage: React.FC = () => {
  const [form, setForm] = useState({ title: '', description: '', image_url: '', badge: '', valid_to: '' });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  const set = (k: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault(); setMsg(''); setError(''); setLoading(true);
    try {
      await adminApi.createPromo({ ...form, valid_to: new Date(form.valid_to).toISOString() });
      setMsg('สร้างโปรโมชันสำเร็จ!');
      setForm({ title: '', description: '', image_url: '', badge: '', valid_to: '' });
    } catch (e: any) { setError(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ maxWidth: 540, margin: '0 auto', width: '100%' }}>
      <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.15em', color: '#888', textTransform: 'uppercase', marginBottom: 2 }}>จัดการโปรโมชัน</p>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 24 }}>เพิ่มโปรโมชันใหม่</h2>

      {msg && <div style={{ borderRadius: 10, padding: '10px 14px', marginBottom: 18, fontSize: 13, background: '#f0fff4', color: '#16a34a', border: '1px solid #86efac' }}>{msg}</div>}
      {error && <div style={{ borderRadius: 10, padding: '10px 14px', marginBottom: 18, fontSize: 13, background: '#fff0f0', color: '#c00', border: '1px solid #fca5a5' }}>{error}</div>}

      <form onSubmit={handleSubmit} style={{ background: '#fff', borderRadius: 16, padding: '24px 20px', border: '1.5px solid #f3f4f6', display: 'flex', flexDirection: 'column', gap: 16 }}>
        {[
          { label: 'ชื่อโปรโมชัน *', key: 'title' as const, placeholder: 'ซื้อ 2 แถม 1', required: true },
          { label: 'Badge (ป้ายสั้น)', key: 'badge' as const, placeholder: 'HOT', required: false },
          { label: 'URL รูปภาพ', key: 'image_url' as const, placeholder: 'https://...', required: false },
        ].map(({ label, key, placeholder, required }) => (
          <div key={key}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 6 }}>{label}</label>
            <input value={form[key]} onChange={set(key)} required={required} placeholder={placeholder}
              style={{ width: '100%', padding: '10px 14px', borderRadius: 10, border: '1.5px solid #e5e7eb', fontSize: 14 }} />
          </div>
        ))}
        <div>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 6 }}>รายละเอียด</label>
          <textarea value={form.description} onChange={set('description')} rows={3} placeholder="รายละเอียดโปรโมชัน..."
            style={{ width: '100%', padding: '10px 14px', borderRadius: 10, border: '1.5px solid #e5e7eb', fontSize: 14, resize: 'vertical' }} />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 6 }}>วันหมดอายุ *</label>
          <input type="date" value={form.valid_to} onChange={set('valid_to')} required
            style={{ width: '100%', padding: '10px 14px', borderRadius: 10, border: '1.5px solid #e5e7eb', fontSize: 14 }} />
        </div>
        <button type="submit" disabled={loading}
          style={{ padding: '14px', borderRadius: 50, border: 'none', background: 'linear-gradient(to right, #f59e0b, #d97706)', color: '#2a1810', fontWeight: 700, fontSize: 15, cursor: 'pointer', marginTop: 4 }}>
          {loading ? 'กำลังบันทึก...' : '+ เพิ่มโปรโมชัน'}
        </button>
      </form>
    </div>
  );
};

export default PromoManagePage;
